<template>
  <centered-box>
    <h3 class="title is-3">{{ $t("Reset password") }}</h3>
    <input-field
      type="text"
      :label="$t('Email')"
      v-model="email"
      @focus="email_onFocus"
      :errors="email_errorsIfTouched"
    />
    <reset-password-button
      :label="$t('Send reset password to e-mail')"
      :email="email"
      :disabled="!group_valid"
      primary="true"
      wide="true"
    />
    <div class="has-text-centered is-p1">
      <router-link to="/login-email">{{
        $t("Or go back to login")
      }}</router-link>
    </div>
  </centered-box>
</template>

<script>
import { InputField, ResetPasswordButton } from "@/components/form"
import { CenteredBox } from "@/components/layout"
import { validator, email, required } from "@/validator"

export default {
  name: "resetPassword",
  mixins: [validator],
  components: {
    InputField,
    CenteredBox,
    ResetPasswordButton
  },
  data() {
    return {
      error: undefined
    }
  },
  validations: {
    email: [required, email]
  }
}
</script>
